import React, { useState } from "react";
import { Button } from "../ui/Button";
import { useToast } from "../../hooks/use-toast";
import LambdaRunStatus from "../shared/LambdaRunStatus";
import { generatePatientNote } from "./patientApi";

const GenerateNoteAction = ({ patientId }) => {
  const { toast } = useToast();
  const [isGenerating, setIsGenerating] = useState(false);
  const [runs, setRuns] = useState([]);

  const handleGenerate = async () => {
    if (!patientId || isGenerating) return;

    setIsGenerating(true);
    setRuns([]);

    const result = await generatePatientNote(patientId);

    setIsGenerating(false);
    // Any invocations that did fire are still worth tracking, even if a later
    // step failed to start.
    setRuns(result.runs || []);

    if (result.success) {
      toast({
        title: "Note generation started",
      });
      return;
    }

    toast({
      variant: "destructive",
      title: "Could not generate note",
      description: result.error || "Failed to start note generation.",
    });
  };

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <Button
        type="button"
        onClick={handleGenerate}
        disabled={isGenerating || !patientId}
        className="bg-ktx-purple hover:bg-purple-700 text-white"
      >
        {isGenerating ? "Starting…" : "Generate Note"}
      </Button>

      <LambdaRunStatus runs={runs} title="Note generation logs" />
    </div>
  );
};

export default GenerateNoteAction;
